<template>
    <vx-table class="xl:grid-cols-5-auto" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Name</div>
            <div>Email</div>
            <div>Current Team</div>
            <div>Status</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
